/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import clsx from 'clsx';
import React from 'react';
import { ProgressBarProps } from './ProgressBar.props';

/**
 * SDS ProgressBar component.
 */
export const ProgressBar = (props: ProgressBarProps): JSX.Element => {
  const { classes, currentValue, maximum, maximumLabel, ...rest } = {
    ...props,
  };

  const percentage = Math.round((currentValue / maximum) * 100);
  const percentageValue = `${percentage}%`;

  const safePercentage = percentage > 100 ? 100 : percentage;
  const safePercentageValue = `${safePercentage}%`;

  let percentageLevel;
  if (percentage > 100) {
    percentageLevel = `extreme`;
  } else if (percentage > 85) {
    percentageLevel = `very-high`;
  } else if (percentage > 75) {
    percentageLevel = `high`;
  } else if (percentage > 50) {
    percentageLevel = `moderate`;
  } else {
    percentageLevel = `low`;
  }

  const currentLabel = currentValue.toLocaleString(undefined, { maximumFractionDigits: 2 });
  const progressLabel = ` of ${maximumLabel}`;

  const progressBarContainerClass = clsx(
    `sds-progress-bar-container`,
    `sds-progress-bar-level--${percentageLevel}`,
    classes,
  );

  return (
    <div className={progressBarContainerClass} {...rest}>
      <div className="sds-progress-bar__stats">
        <div className="sds-progress-bar__percentage">
          <span>{percentageValue}</span>
        </div>
        <div className="sds-progress-bar__limits">
          <span className="sds-progress-bar__current-value">{currentLabel}</span>
          <span>{progressLabel}</span>
        </div>
      </div>
      <div className="sds-progress-bar">
        <div className="sds-progress-bar__indicator" style={{ width: safePercentageValue }}></div>
      </div>
    </div>
  );
};
